// @ts-ignore
import { createAsyncThunk } from '@reduxjs/toolkit';
// @ts-ignore
import axios from 'axios';
import * as process from 'process';
import { getSessionStorage, setSessionStorage } from '@/utils';
import { webCookie } from '@/utils/webCookie';
import { isWebViewClient } from '@/utils/omniture';

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SERVICE_URL,
});

export const insertFixedApplication = createAsyncThunk<any, any>(
  'insertFixedApplication',
  async (data: any) => {
    const { sid, formName, trackingCid, tbg }: any = data;
    const params: any = new URLSearchParams();

    const storedData = getSessionStorage('userData');
    params.append('method', 'insertFixedApplication');
    params.append('sid', storedData?.sid || sid);

    if (webCookie.get('perso_id')) {
      params.append(
        'persoId',
        webCookie.get('perso_id')?.replace(/\|/g, '%7C') as string
      );
    }
    if (webCookie.get('multi_perso_id')) {
      params.append(
        'multiPersoId',
        webCookie.get('multi_perso_id')?.replace(/\|/g, '%7C') as string
      );
    }
    if (trackingCid || getSessionStorage('trackingCid')) {
      params.append(
        'trackingCid',
        trackingCid || String(getSessionStorage('trackingCid'))
      );
    }
    if (tbg || getSessionStorage('tbg')) {
      params.append('tbg', tbg || String(getSessionStorage('tbg')));
    }
    if (webCookie.get('is_funnel')) {
      params.append('isFunnel', webCookie.get('is_funnel'));
    }
    if (storedData?.formName) {
      params.append('formName', formName || storedData?.formName);
    } else {
      params.append(
        'formName',
        formName || storedData?.formName || 'Full Form'
      );
    }
    if (storedData?.tags) {
      params.append('tags', storedData.tags);
    }
    if (storedData?.referer && storedData?.referer?.length > 0) {
      params.append(
        'referer',
        storedData.referer || getSessionStorage('referer')
      );
    }
    if (webCookie.get('source_id')) {
      params.append(
        'sourceId',
        webCookie.get('source_id')?.replace(/\|/g, '%7C') as string
      );
    }
    if (webCookie.get('multi_sourceID')) {
      params.append(
        'multiSourceId',
        webCookie.get('multi_sourceID')?.replace(/\|/g, '%7C') as string
      );
    }
    const sourceId =
      isWebViewClient() && window?.clientVariables?.source_id_app;

    const res = await instance
      .post('/', '', {
        params: params,
        headers: {
          ...(sourceId && { source_id_app: sourceId }), // Add source-id header if it exists
        },
      })
      .then((response: any) => response.data);

    return res;
  }
);

export const getApplicationAddress = createAsyncThunk<any, any>(
  'getApplicationAddress',

  async (sid: string) => {
    const data: any = {};
    const storedData = getSessionStorage('userData');
    data.method = 'getApplicationAddress';
    data.sid = sid;

    const res = await instance
      .post('/', '', {
        params: data,
      })
      .then((response: any) => response.data);

    return res;
  }
);

export const saveAddressInfo = createAsyncThunk<any, any>(
  'saveAddressInfo',
  async (data: any) => {
    const { site, address, appId }: any = data;
    const {
      city,
      district,
      town,
      village,
      neighborhood,
      street,
      streetUavId,
      buildingNo,
      buildingUavtCode,
      apartmentNo,
      apartmentCode,
    }: any = address;
    const storedData = getSessionStorage('userData');

    const params = new URLSearchParams();
    params.append('method', 'saveAddressInfo');
    params.append('city', city || address?.cities?.name);
    params.append('district', district || address?.districts?.name);
    params.append('town', town || address?.towns?.name);
    params.append('village', village || address?.villages?.name);
    params.append('neighborhood', neighborhood || address?.neighborhoods?.name);
    params.append('street', street || address?.streets?.name);
    params.append('streetUavId', streetUavId || address?.streets?.id);
    params.append('buildingNo', buildingNo || address?.buildings?.name);
    params.append(
      'buildingUavtCode',
      buildingUavtCode || address?.buildings?.id
    );
    params.append(
      'addressNumber',

      storedData?.address?.buildingDivisions?.addressNumber ||
        storedData?.address?.addressNumber ||
        storedData?.applicationAddress?.addressNumber
    );
    params.append('applicationId', storedData?.appId || appId);
    if (storedData?.formName) {
      params.append('formName', storedData?.formName);
    } else {
      params.append('formName', 'Full Form');
    }
    params.append('sid', storedData?.sid);
    params.append(
      'apartmentNo',
      apartmentNo || address?.buildingDivisions?.name
    );
    params.append(
      'apartmentCode',
      apartmentCode || address?.buildingDivisions?.id
    );
    if (address?.siteDoorNumber && address?.siteName) {
      params.append('siteDoorNumber', address?.siteDoorNumber);
      params.append('siteName', address?.siteName);
    } else if (site?.doorNumber && site?.name) {
      params.append('siteDoorNumber', site?.doorNumber);
      params.append('siteName', site?.name);
    }

    const res = await instance
      .post('/', params)
      .then((response: any) => response.data);
    return res;
  }
);

export const queryFixedInfrastructure = createAsyncThunk<any, any>(
  'queryFixedInfrastructure',
  async (data: any) => {
    const { site, infraTypes }: any = data;
    const params = new URLSearchParams();
    const storedData = getSessionStorage('userData');
    params.append('method', 'queryFixedInfrastructure');
    params.append('city', storedData?.address?.cities?.name);
    params.append('district', storedData?.address?.districts?.name);
    params.append('town', storedData?.address?.towns?.name);
    params.append('village', storedData?.address?.villages?.name);
    params.append('neighborhood', storedData?.address?.neighborhoods?.name);
    params.append('street', storedData?.address?.streets?.name);
    params.append('streetUavId', storedData?.address?.streets?.id);
    params.append('buildingNo', storedData?.address?.buildings?.name);
    params.append('buildingUavtCode', storedData?.address?.buildings?.id);
    params.append('applicationId', storedData?.appId);
    if (storedData?.formName) {
      params.append('formName', storedData?.formName);
    } else {
      params.append('formName', 'Full Form');
    }
    params.append('sid', storedData?.sid);
    params.append('queryTypes', infraTypes);
    params.append('apartmentNo', storedData?.address?.buildingDivisions?.name);
    params.append('apartmentCode', storedData?.address?.buildingDivisions?.id);
    if (site) {
      params.append('siteDoorNumber', site?.doorNumber);
      params.append('siteName', site?.name);
    }
    const res = await instance
      .post('/', params)
      .then((response: any) => response.data);
    return res;
  }
);

export const getAddressData = createAsyncThunk<any, any>(
  'getAddressData',
  async (data: any) => {
    const { sid, appId, type, id }: any = data;
    const params = new URLSearchParams();
    params.append('method', 'getAddressData');
    params.append('sid', sid);
    params.append('applicationId', appId);
    params.append('type', type);
    params.append('id', id);

    const res = await instance
      .post('/', '', {
        params: params,
      })
      .then((response: any) => response.data);
    return res;
  }
);

export const saveFixedTariff = createAsyncThunk<any, any>(
  'saveFixedTariff',
  async (data: any) => {
    const { id }: any = data;
    const storedData = getSessionStorage('userData');
    const upsellAction = getSessionStorage('upsellAction');
    const params: any = new URLSearchParams();
    params.append('method', 'saveFixedTariff');
    params.append('applicationId', storedData?.appId);
    params.append('tariffId', id);
    params.append('usePromo', false);
    params.append('addons', '');
    params.append('sid', storedData?.sid);
    params.append('vkn', '');
    params.append('taxOfficeName', '');
    params.append('signatureAuthority', '');
    if (!!upsellAction) {
      params.append('upsellAction', upsellAction);
    }

    const res = await instance
      .post('/', '', {
        params: params,
      })
      .then((response: any) => response.data);
    return res;
  }
);

export const queryFixTariffs = createAsyncThunk('queryFixTariffs', async () => {
  const storedData = getSessionStorage('userData');
  const params: any = new URLSearchParams();
  params.append('method', 'queryFixTariffs');
  params.append('sid', storedData?.sid);
  params.append('applicationId', storedData?.appId);
  params.append('isCorporate', false);
  getSessionStorage('couponCode') != null &&
    params.append('couponCode', getSessionStorage('couponCode').trim(''));
  if (storedData.tags && storedData.tags.length > 0) {
    params.append('flags', storedData?.tags);
  }
  if (sessionStorage.getItem('hiddenTariffs')) {
    params.append('hiddenTariffs', sessionStorage.getItem('hiddenTariffs'));
  }

  const res = await instance
    .post('/', '', {
      params: params,
    })
    .then((response: any) => response.data);

  return res;
});

export const getSiteInfoList = createAsyncThunk<any, any>(
  'getSiteInfoList',
  async (data: any) => {
    const { sid, appData }: any = data;
    const params = new URLSearchParams();
    const storedData = getSessionStorage('userData');
    params.append('method', 'getSiteInfoList');
    params.append('sid', sid);
    params.append('apartmentCode', appData?.buildingDivisions?.id);
    params.append('cityName', appData?.cities?.name);
    params.append('districtName', appData?.districts?.name);
    params.append('neighborhoodName', appData?.neighborhoods?.name);
    params.append('streetName', appData?.streets?.name);
    params.append('buildingUavt', appData?.buildings?.id);

    if (storedData?.formName) {
      params.append('formName', storedData?.formName);
    } else {
      params.append('formName', 'Full Form');
    }

    const res = await instance
      .post('/', '', {
        params: params,
      })
      .then((response: any) => response.data);
    return res;
  }
);
export const getPersonalInfo = createAsyncThunk('getPersonalInfo', async () => {
  const params = new URLSearchParams();
  const storedData = getSessionStorage('userData');
  params.append('method', 'getPersonalInfo');
  params.append('sid', storedData?.sid);
  params.append('applicationId', storedData?.appId);
  const res = await instance
    .post('/', '', {
      params: params,
    })
    .then((response: any) => response.data);
  return res;
});

export const updatePersonalInfo = createAsyncThunk<any, any>(
  'updatePersonalInfo',
  async (data: any) => {
    const { userInfo }: any = data;
    const { targetCaseEmailIsActive }: any = data;
    const params: any = new URLSearchParams();
    const storedData = getSessionStorage('userData');
    params.append('method', 'updatePersonalInfo');
    params.append('sid', storedData?.sid);
    params.append('applicationId', storedData?.appId);
    params.append(
      'email',
      targetCaseEmailIsActive ? 'dummyemail@gmail.com' : userInfo?.email
    );
    params.append('deliveryType', userInfo?.selectedBilling.value);
    params.append('tckn', '11111111110');
    params.append('name', userInfo?.name);
    params.append('gender', '');
    params.append('surname', userInfo?.surname);
    params.append('otherUser', true);
    params.append('birthDate', '1999-08-01');
    const res = await instance
      .post('/', '', {
        params: params,
      })
      .then((response: any) => response.data);
    return res;
  }
);

// MSISDN_FACEBOOK("14FEFF71B5FEEFE358BCB02B24ABC77945C02F1D59897BA4F1DE4B8606B2E4BC"), //
// MSISDN_GOOGLE("9817EE232E9775F695A9BB7DD0FA1E3C35FA4847E710D8846B752F1424EAD7F6"),//
// NAME("EAA589322731009980D99891B5C7850AC5172DDA7CDF73A533AB403332D7E944"), //
// SURNAME("3F3D2313D213444A00BFD5F5E39915D8124A9E174FB2B85C4B2AB6D267E157E6"), //
// EMAIL("72D90AF393D610727BDF1FA58D1010C116F263AE7CE096EEB7EB36C2AE646791");

export const getDataInsights = createAsyncThunk<any, any>(
  'getDataInsights',
  async (data: any) => {
    const { appId, sid } = data;
    const params: any = new URLSearchParams();
    const storedData = getSessionStorage('userData');
    params.append('method', 'getDataInsights');
    params.append('sid', sid);
    params.append('appId', appId);

    const body = {
      email: storedData?.userInfo?.email || ' ',
    };
    const res = await instance
      .post('/', body, {
        params: params,
      })
      .then((response: any) => response.data);

    return res;
  }
);

export const insertFixedColdLead = createAsyncThunk<any, any>(
  'insertFixedColdLead',
  async (data: any) => {
    const { actionType } = data;
    const params: any = new URLSearchParams();
    const storedData = getSessionStorage('userData');
    params.append('method', 'insertFixedColdLead');
    params.append('sid', storedData?.sid);

    const body = {
      appId: storedData?.appId,
      addressCode:
        storedData?.address?.buildingDivisions?.id ||
        storedData?.applicationAddress?.apartmentCode,
      actionType: actionType,
      city:
        storedData?.address?.cities?.name ||
        storedData?.applicationAddress?.city,
      district:
        storedData?.address?.districts?.name ||
        storedData?.applicationAddress?.district,
      town:
        storedData?.address?.towns?.name ||
        storedData?.applicationAddress?.town,
      village:
        storedData?.address?.villages?.name ||
        storedData?.applicationAddress?.village,
      neighborhood:
        storedData?.address?.neighborhoods?.name ||
        storedData?.applicationAddress?.neighborhood,
      street:
        storedData?.address?.streets?.name ||
        storedData?.applicationAddress?.street,
      streetUavId:
        storedData?.address?.streets?.id ||
        storedData?.applicationAddress?.streetUavId,
      buildingNo:
        storedData?.address?.buildings?.name ||
        storedData?.applicationAddress?.buildingNo,
      buildingUavtCode:
        storedData?.address?.buildings?.id ||
        storedData?.applicationAddress?.buildingUavtCode,
      apartmentNo:
        storedData?.address?.buildingDivisions?.name ||
        storedData?.applicationAddress?.apartmentNo,
      siteName:
        storedData?.address?.siteName ||
        storedData?.applicationAddress?.siteName,
      siteDoorNumber:
        storedData?.address?.siteDoorNumber ||
        storedData?.applicationAddress?.siteDoorNumber,
    };
    const res = await instance
      .post('/', body, {
        params: params,
      })
      .then((response: any) => response.data);

    return res;
  }
);
